import React from 'react';
import { QuarterlyCampaign } from '../../lib/types';
import { formatCurrency } from '../../lib/export';

interface QuarterlyCampaignsTableProps {
  data: QuarterlyCampaign[];
  className?: string;
}

export function QuarterlyCampaignsTable({ data, className = '' }: QuarterlyCampaignsTableProps) {
  const getStatusBadge = (status: string) => {
    const statusColors = {
      upcoming: 'bg-blue-100 text-blue-800',
      active: 'bg-green-100 text-green-800',
      completed: 'bg-gray-100 text-gray-800'
    };
    return statusColors[status as keyof typeof statusColors] || statusColors.upcoming;
  };

  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Quarterly Campaigns</h3>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-900">Campaign Name</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Quarter</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Date Range</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Status</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Estimated Impact</th>
            </tr>
          </thead>
          <tbody>
            {data.map((campaign) => (
              <tr key={campaign.campaignId} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{campaign.campaignName}</td>
                <td className="py-3 px-4 text-sm text-gray-600">
                  {campaign.quarter} {campaign.year}
                </td>
                <td className="py-3 px-4 text-sm text-gray-600">
                  {new Date(campaign.startDate).toLocaleDateString()} - {new Date(campaign.endDate).toLocaleDateString()}
                </td>
                <td className="py-3 px-4 text-sm">
                  <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(campaign.status)}`}>
                    {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-right font-medium text-green-600">
                  {formatCurrency(campaign.estimatedImpact)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

